import { useAuth0 } from '@auth0/auth0-react'
import { isReverStaff } from '@/domain/dashboard-user'
import { useAppSelector } from '@/redux/hooks'

// Auth0 has the email before getMe answers; only getMe has the group.
export function useIsReverStaff() {
  const { user } = useAuth0()
  const me = useAppSelector((s) => s.userApi.getMe.response.user)
  return isReverStaff({
    email: user?.email ?? user?.name ?? me?.name,
    group: me?.group
  })
}
